import { render } from "./HaveNftButton.vue?vue&type=template&id=22d564f8&scoped=true"
import script from "./HaveNftButton.vue?vue&type=script&lang=js"
export * from "./HaveNftButton.vue?vue&type=script&lang=js"

import "./HaveNftButton.vue?vue&type=style&index=0&id=22d564f8&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d564f8"]])

export default __exports__